module.exports = __webpack_public_path__ + "static/media/01C.8aa6c796.png";